"use client";

import { c as _c } from "react/compiler-runtime";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { PlusIcon } from "lucide-react";
import Link from "next/link";
import { Accordion, AccordionContent, AccordionItem } from "@/lib/components/accordion";
import { useI18n } from "@llmgateway/i18n/react";
export function Faq() {
  const $ = _c(154);
  const {
    t
  } = useI18n();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["openRouter", "models", "uptime", "pricing"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[1] !== t) {
    const faqData = t0.map(item => ({
      question: t(`landing.faq.items.${item}.question`),
      answer: t(`landing.faq.items.${item}.schemaAnswer`)
    }));
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqData.map(_temp)
    };
    t3 = "w-full py-20 md:py-32 bg-background";
    t4 = "faq";
    t2 = "application/ld+json";
    t1 = JSON.stringify(faqSchema);
    $[1] = t;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t1) {
    t5 = {
      __html: t1
    };
    $[6] = t1;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t5) {
    t6 = <script type={t2} dangerouslySetInnerHTML={t5} />;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t("landing.faq.eyebrow");
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7) {
    t8 = <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground mb-4">{t7}</p>;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t) {
    t9 = t("landing.faq.title");
    $[15] = t;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t9) {
    t10 = <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-foreground">{t9}</h2>;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t) {
    t11 = t("landing.faq.description");
    $[19] = t;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11) {
    t12 = <p className="mt-4 text-muted-foreground">{t11}</p>;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t) {
    t13 = t("landing.faq.contactPrefix");
    $[23] = t;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t) {
    t14 = t("landing.faq.contactLink");
    $[25] = t;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t14) {
    t15 = <a href="mailto:contact@doteb.com" className="text-foreground underline underline-offset-4">{t14}</a>;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t13 || $[30] !== t15) {
    t16 = <p className="mt-6 text-sm text-muted-foreground">{t13}{" "}{t15}</p>;
    $[29] = t13;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t10 || $[33] !== t12 || $[34] !== t16 || $[35] !== t8) {
    t17 = <div className="lg:col-span-2 lg:sticky lg:top-24 lg:self-start">{t8}{t10}{t12}{t16}</div>;
    $[32] = t10;
    $[33] = t12;
    $[34] = t16;
    $[35] = t8;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t) {
    t18 = t("landing.faq.items.openRouter.question");
    $[37] = t;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <PlusIcon size={18} className="pointer-events-none shrink-0 opacity-60 transition-transform duration-200" aria-hidden="true" />;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t18) {
    t20 = <AccordionPrimitive.Header className="flex"><AccordionPrimitive.Trigger className="focus-visible:border-ring focus-visible:ring-ring/50 flex flex-1 items-center justify-between gap-4 rounded-md py-2 text-left font-display text-lg md:text-xl font-medium leading-7 transition-all outline-none focus-visible:ring-[3px] disabled:pointer-events-none disabled:opacity-50 [&>svg>path:last-child]:origin-center [&>svg>path:last-child]:transition-all [&>svg>path:last-child]:duration-200 [&[data-state=open]>svg]:rotate-180 [&[data-state=open]>svg>path:last-child]:rotate-90 [&[data-state=open]>svg>path:last-child]:opacity-0 text-foreground">{t18}{t19}</AccordionPrimitive.Trigger></AccordionPrimitive.Header>;
    $[40] = t18;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== t) {
    t21 = t("landing.faq.items.openRouter.intro");
    $[42] = t;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== t21) {
    t22 = <p>{t21}</p>;
    $[44] = t21;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] !== t) {
    t23 = t("landing.faq.items.openRouter.point1");
    $[46] = t;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== t23) {
    t24 = <li>{t23}</li>;
    $[48] = t23;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  let t25;
  if ($[50] !== t) {
    t25 = t("landing.faq.items.openRouter.point2");
    $[50] = t;
    $[51] = t25;
  } else {
    t25 = $[51];
  }
  let t26;
  if ($[52] !== t25) {
    t26 = <li>{t25}</li>;
    $[52] = t25;
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  let t27;
  if ($[54] !== t) {
    t27 = t("landing.faq.items.openRouter.point3");
    $[54] = t;
    $[55] = t27;
  } else {
    t27 = $[55];
  }
  let t28;
  if ($[56] !== t27) {
    t28 = <li>{t27}</li>;
    $[56] = t27;
    $[57] = t28;
  } else {
    t28 = $[57];
  }
  let t29;
  if ($[58] !== t) {
    t29 = t("landing.faq.items.openRouter.point4");
    $[58] = t;
    $[59] = t29;
  } else {
    t29 = $[59];
  }
  let t30;
  if ($[60] !== t29) {
    t30 = <li>{t29}</li>;
    $[60] = t29;
    $[61] = t30;
  } else {
    t30 = $[61];
  }
  let t31;
  if ($[62] !== t24 || $[63] !== t26 || $[64] !== t28 || $[65] !== t30) {
    t31 = <ul className="list-disc pl-6 mt-2 space-y-1">{t24}{t26}{t28}{t30}</ul>;
    $[62] = t24;
    $[63] = t26;
    $[64] = t28;
    $[65] = t30;
    $[66] = t31;
  } else {
    t31 = $[66];
  }
  let t32;
  if ($[67] !== t22 || $[68] !== t31) {
    t32 = <AccordionContent className="overflow-hidden transition-all data-[state=open]:animate-accordion-down data-[state=closed]:animate-accordion-up text-base text-muted-foreground leading-relaxed pb-2"><div className="border-l-2 border-foreground/10 pl-4">{t22}{t31}</div></AccordionContent>;
    $[67] = t22;
    $[68] = t31;
    $[69] = t32;
  } else {
    t32 = $[69];
  }
  let t33;
  if ($[70] !== t20 || $[71] !== t32) {
    t33 = <AccordionItem value="item-1" className="py-5 border-border/50">{t20}{t32}</AccordionItem>;
    $[70] = t20;
    $[71] = t32;
    $[72] = t33;
  } else {
    t33 = $[72];
  }
  let t34;
  if ($[73] !== t) {
    t34 = t("landing.faq.items.models.question");
    $[73] = t;
    $[74] = t34;
  } else {
    t34 = $[74];
  }
  let t35;
  if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <PlusIcon size={18} className="pointer-events-none shrink-0 opacity-60 transition-transform duration-200" aria-hidden="true" />;
    $[75] = t35;
  } else {
    t35 = $[75];
  }
  let t36;
  if ($[76] !== t34) {
    t36 = <AccordionPrimitive.Header className="flex"><AccordionPrimitive.Trigger className="focus-visible:border-ring focus-visible:ring-ring/50 flex flex-1 items-center justify-between gap-4 rounded-md py-2 text-left font-display text-lg md:text-xl font-medium leading-7 transition-all outline-none focus-visible:ring-[3px] disabled:pointer-events-none disabled:opacity-50 [&>svg>path:last-child]:origin-center [&>svg>path:last-child]:transition-all [&>svg>path:last-child]:duration-200 [&[data-state=open]>svg]:rotate-180 [&[data-state=open]>svg>path:last-child]:rotate-90 [&[data-state=open]>svg>path:last-child]:opacity-0 text-foreground">{t34}{t35}</AccordionPrimitive.Trigger></AccordionPrimitive.Header>;
    $[76] = t34;
    $[77] = t36;
  } else {
    t36 = $[77];
  }
  let t37;
  if ($[78] !== t) {
    t37 = t("landing.faq.items.models.answerPrefix");
    $[78] = t;
    $[79] = t37;
  } else {
    t37 = $[79];
  }
  let t38;
  if ($[80] !== t) {
    t38 = t("landing.faq.items.models.modelsPage");
    $[80] = t;
    $[81] = t38;
  } else {
    t38 = $[81];
  }
  let t39;
  if ($[82] !== t38) {
    t39 = <Link href="/models" className="underline">{t38}</Link>;
    $[82] = t38;
    $[83] = t39;
  } else {
    t39 = $[83];
  }
  let t40;
  if ($[84] !== t) {
    t40 = t("landing.faq.items.models.answerSuffix");
    $[84] = t;
    $[85] = t40;
  } else {
    t40 = $[85];
  }
  let t41;
  if ($[86] !== t37 || $[87] !== t39 || $[88] !== t40) {
    t41 = <AccordionContent className="overflow-hidden transition-all data-[state=open]:animate-accordion-down data-[state=closed]:animate-accordion-up text-base text-muted-foreground leading-relaxed pb-2"><div className="border-l-2 border-foreground/10 pl-4">{t37}{" "}{t39}{" "}{t40}</div></AccordionContent>;
    $[86] = t37;
    $[87] = t39;
    $[88] = t40;
    $[89] = t41;
  } else {
    t41 = $[89];
  }
  let t42;
  if ($[90] !== t36 || $[91] !== t41) {
    t42 = <AccordionItem value="item-2" className="py-5 border-border/50">{t36}{t41}</AccordionItem>;
    $[90] = t36;
    $[91] = t41;
    $[92] = t42;
  } else {
    t42 = $[92];
  }
  let t43;
  if ($[93] !== t) {
    t43 = t("landing.faq.items.uptime.question");
    $[93] = t;
    $[94] = t43;
  } else {
    t43 = $[94];
  }
  let t44;
  if ($[95] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = <PlusIcon size={18} className="pointer-events-none shrink-0 opacity-60 transition-transform duration-200" aria-hidden="true" />;
    $[95] = t44;
  } else {
    t44 = $[95];
  }
  let t45;
  if ($[96] !== t43) {
    t45 = <AccordionPrimitive.Header className="flex"><AccordionPrimitive.Trigger className="focus-visible:border-ring focus-visible:ring-ring/50 flex flex-1 items-center justify-between gap-4 rounded-md py-2 text-left font-display text-lg md:text-xl font-medium leading-7 transition-all outline-none focus-visible:ring-[3px] disabled:pointer-events-none disabled:opacity-50 [&>svg>path:last-child]:origin-center [&>svg>path:last-child]:transition-all [&>svg>path:last-child]:duration-200 [&[data-state=open]>svg]:rotate-180 [&[data-state=open]>svg>path:last-child]:rotate-90 [&[data-state=open]>svg>path:last-child]:opacity-0 text-foreground">{t43}{t44}</AccordionPrimitive.Trigger></AccordionPrimitive.Header>;
    $[96] = t43;
    $[97] = t45;
  } else {
    t45 = $[97];
  }
  let t46;
  if ($[98] !== t) {
    t46 = t("landing.faq.items.uptime.answer");
    $[98] = t;
    $[99] = t46;
  } else {
    t46 = $[99];
  }
  let t47;
  if ($[100] !== t46) {
    t47 = <AccordionContent className="overflow-hidden transition-all data-[state=open]:animate-accordion-down data-[state=closed]:animate-accordion-up text-base text-muted-foreground leading-relaxed pb-2"><div className="border-l-2 border-foreground/10 pl-4">{t46}</div></AccordionContent>;
    $[100] = t46;
    $[101] = t47;
  } else {
    t47 = $[101];
  }
  let t48;
  if ($[102] !== t45 || $[103] !== t47) {
    t48 = <AccordionItem value="item-3" className="py-5 border-border/50">{t45}{t47}</AccordionItem>;
    $[102] = t45;
    $[103] = t47;
    $[104] = t48;
  } else {
    t48 = $[104];
  }
  let t49;
  if ($[105] !== t) {
    t49 = t("landing.faq.items.pricing.question");
    $[105] = t;
    $[106] = t49;
  } else {
    t49 = $[106];
  }
  let t50;
  if ($[107] === Symbol.for("react.memo_cache_sentinel")) {
    t50 = <PlusIcon size={18} className="pointer-events-none shrink-0 opacity-60 transition-transform duration-200" aria-hidden="true" />;
    $[107] = t50;
  } else {
    t50 = $[107];
  }
  let t51;
  if ($[108] !== t49) {
    t51 = <AccordionPrimitive.Header className="flex"><AccordionPrimitive.Trigger className="focus-visible:border-ring focus-visible:ring-ring/50 flex flex-1 items-center justify-between gap-4 rounded-md py-2 text-left font-display text-lg md:text-xl font-medium leading-7 transition-all outline-none focus-visible:ring-[3px] disabled:pointer-events-none disabled:opacity-50 [&>svg>path:last-child]:origin-center [&>svg>path:last-child]:transition-all [&>svg>path:last-child]:duration-200 [&[data-state=open]>svg]:rotate-180 [&[data-state=open]>svg>path:last-child]:rotate-90 [&[data-state=open]>svg>path:last-child]:opacity-0 text-foreground">{t49}{t50}</AccordionPrimitive.Trigger></AccordionPrimitive.Header>;
    $[108] = t49;
    $[109] = t51;
  } else {
    t51 = $[109];
  }
  let t52;
  if ($[110] !== t) {
    t52 = t("landing.faq.items.pricing.intro");
    $[110] = t;
    $[111] = t52;
  } else {
    t52 = $[111];
  }
  let t53;
  if ($[112] !== t52) {
    t53 = <p>{t52}</p>;
    $[112] = t52;
    $[113] = t53;
  } else {
    t53 = $[113];
  }
  let t54;
  if ($[114] !== t) {
    t54 = t("landing.faq.items.pricing.credits");
    $[114] = t;
    $[115] = t54;
  } else {
    t54 = $[115];
  }
  let t55;
  if ($[116] !== t54) {
    t55 = <li>{t54}</li>;
    $[116] = t54;
    $[117] = t55;
  } else {
    t55 = $[117];
  }
  let t56;
  if ($[118] !== t) {
    t56 = t("landing.faq.items.pricing.byok");
    $[118] = t;
    $[119] = t56;
  } else {
    t56 = $[119];
  }
  let t57;
  if ($[120] !== t56) {
    t57 = <li>{t56}</li>;
    $[120] = t56;
    $[121] = t57;
  } else {
    t57 = $[121];
  }
  let t58;
  if ($[122] !== t) {
    t58 = t("landing.faq.items.pricing.enterprise");
    $[122] = t;
    $[123] = t58;
  } else {
    t58 = $[123];
  }
  let t59;
  if ($[124] !== t58) {
    t59 = <li>{t58}</li>;
    $[124] = t58;
    $[125] = t59;
  } else {
    t59 = $[125];
  }
  let t60;
  if ($[126] !== t) {
    t60 = t("landing.faq.items.pricing.selfHost");
    $[126] = t;
    $[127] = t60;
  } else {
    t60 = $[127];
  }
  let t61;
  if ($[128] !== t60) {
    t61 = <li>{t60}</li>;
    $[128] = t60;
    $[129] = t61;
  } else {
    t61 = $[129];
  }
  let t62;
  if ($[130] !== t55 || $[131] !== t57 || $[132] !== t59 || $[133] !== t61) {
    t62 = <ul className="list-disc pl-6 mt-2 space-y-1">{t55}{t57}{t59}{t61}</ul>;
    $[130] = t55;
    $[131] = t57;
    $[132] = t59;
    $[133] = t61;
    $[134] = t62;
  } else {
    t62 = $[134];
  }
  let t63;
  if ($[135] !== t53 || $[136] !== t62) {
    t63 = <AccordionContent className="overflow-hidden transition-all data-[state=open]:animate-accordion-down data-[state=closed]:animate-accordion-up text-base text-muted-foreground leading-relaxed pb-2"><div className="border-l-2 border-foreground/10 pl-4">{t53}{t62}</div></AccordionContent>;
    $[135] = t53;
    $[136] = t62;
    $[137] = t63;
  } else {
    t63 = $[137];
  }
  let t64;
  if ($[138] !== t51 || $[139] !== t63) {
    t64 = <AccordionItem value="item-4" className="py-5 border-border/50">{t51}{t63}</AccordionItem>;
    $[138] = t51;
    $[139] = t63;
    $[140] = t64;
  } else {
    t64 = $[140];
  }
  let t65;
  if ($[141] !== t33 || $[142] !== t42 || $[143] !== t48 || $[144] !== t64) {
    t65 = <div className="lg:col-span-3"><Accordion type="single" collapsible={true} className="w-full" defaultValue="item-1">{t33}{t42}{t48}{t64}</Accordion></div>;
    $[141] = t33;
    $[142] = t42;
    $[143] = t48;
    $[144] = t64;
    $[145] = t65;
  } else {
    t65 = $[145];
  }
  let t66;
  if ($[146] !== t17 || $[147] !== t65) {
    t66 = <div className="container mx-auto px-4 md:px-6"><div className="grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-16">{t17}{t65}</div></div>;
    $[146] = t17;
    $[147] = t65;
    $[148] = t66;
  } else {
    t66 = $[148];
  }
  let t67;
  if ($[149] !== t3 || $[150] !== t4 || $[151] !== t6 || $[152] !== t66) {
    t67 = <section className={t3} id={t4}>{t6}{t66}</section>;
    $[149] = t3;
    $[150] = t4;
    $[151] = t6;
    $[152] = t66;
    $[153] = t67;
  } else {
    t67 = $[153];
  }
  return t67;
}
function _temp(item_0) {
  return {
    "@type": "Question",
    name: item_0.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: item_0.answer
    }
  };
}